import transactionService from '../services/transaction.service';

export const transactions = {
  state: {
    transactions: [],
    corporateEvents: [],
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allDeposits: (state) => state.transactions.filter(t => t.TransactionCodeID == 1),
    unconfirmedDeposits: (state) => {return [state.transactions.filter(t => t.CheckerID == 0).filter(t => t.TransactionCodeID == 1),[state.transactions.title = "Contributions"]]},
    allWithdrawals: (state) => state.transactions.filter(t => t.TransactionCodeID == 2),
    unconfirmedWithdrawals: (state) => {return [state.transactions.filter(t => t.CheckerID == 0).filter(t => t.TransactionCodeID == 2),[state.transactions.title = "Withdrawals"]]},
    allCreditAdjustments: (state) => state.transactions.filter(t => t.TransactionCodeID == 3),
    unconfirmedCreditAdjustments: (state) => {return [state.transactions.filter(t => t.CheckerID == 0).filter(t => t.TransactionCodeID == 3),[state.transactions.title = "Credit Adjustments"]]},
    allDebitAdjustments: (state) => state.transactions.filter(t => t.TransactionCodeID == 4),
    unconfirmedDebitAdjustments: (state) => {return [state.transactions.filter(t => t.CheckerID == 0).filter(t => t.TransactionCodeID == 4),[state.transactions.title = "Debit Adjustments"]]},
    allIncomes: (state) => state.transactions.filter(t => t.TransactionCodeID == 64),
    unconfirmedIncomes: (state) => {return [state.transactions.filter(t => t.CheckerID == 0).filter(t => t.TransactionCodeID == 64),[state.transactions.title = "Income Transactions"]]},
    allCorpEvents: (state) => state.corporateEvents,
    unconfirmedCorpEvents: (state) => {return [state.corporateEvents.filter(c => c.CheckerID == 0),[state.corporateEvents.title = "Corporate Events"]]},
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTIONS

  createTransaction({ commit }, data) {
      return transactionService.createTransaction(data).then(
        response => {
          commit('newTransaction', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllTransactions({ commit }) {
      return transactionService.getAllTransactions().then(
        response => {
          commit('setTransactions', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTransaction({ commit }, data) {
      return transactionService.updateTransaction(data.TxnId, data).then(
        response => {
          commit('updTransaction', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CORPORATE EVENTS

  createCorpEvent({ commit }, data) {
      return transactionService.createCorpEvent(data).then(
        response => {
          commit('newCorpEvent', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCorpEvents({ commit }) {
      return transactionService.getAllCorpEvents().then(
        response => {
          commit('setCorpEvents', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCorpEvent({ commit }, data) {
      return transactionService.updateCorpEvent(data.CorporateEventID, data).then(
        response => {
          commit('updCorpEvent', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCorpEvent({ commit }, data) {
      return transactionService.deleteCorpEvent(data.CorporateEventID).then(
        response => {
          commit('dltCorpEvent', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },

//********************************************************************MUTATIONS***************************************************************************************
//********************************************************************************************************************************************************************
  mutations: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTIONS

    setTransactions: (state, transactions) => (state.transactions = transactions),
    newTransaction: (state, newTransaction) => state.transactions.unshift(newTransaction.a_transaction),
    updTransaction: (state, updatedTransaction) => {
      const index = state.transactions.findIndex(transactions => transactions.TxnId === updatedTransaction.TxnId);
      if (index !== -1) {
        state.transactions.splice(index, 1, updatedTransaction);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CORPORATE EVENTS

    setCorpEvents: (state, CorpEvents) => (state.corporateEvents = CorpEvents),
    newCorpEvent: (state, newCorpEvent) => state.corporateEvents.unshift(newCorpEvent.corp_event),
    updCorpEvent: (state, updatedCorpEvent) => {
      const index = state.corporateEvents.findIndex(c => c.CorporateEventID === updatedCorpEvent.CorporateEventID);
      if (index !== -1) {
        state.corporateEvents.splice(index, 1, updatedCorpEvent);
      }
    },
    dltCorpEvent: (state, CorpEvent) => {
      const index = state.corporateEvents.findIndex(c => c.CorporateEventID === CorpEvent.CorporateEventID);
      if (index !== -1) {
        state.corporateEvents.splice(index, 1);
      }
    },
  },
}
